import React from 'react'
import { useOutletContext } from 'react-router-dom'
import BulkOperations from './BulkOperations'
import DelegateAccessToken from './DelegateAccessToken'
import DevelopmentOffers from './Offers'
import WebhookSettings from './WebhookSettings'

function Shopify() {
  const { partner, listing } = useOutletContext()

  return (
    <>
      <BulkOperations appId={partner?.sourceKey} listingId={listing?.id} />
      <DelegateAccessToken appId={partner?.sourceKey} listingId={listing?.id} />
      <DevelopmentOffers appId={partner?.sourceKey} />
      <WebhookSettings appId={partner?.sourceKey} />
    </>
  )
}

export default Shopify
